<script setup>
import LeadsFiltersEditWrapper from "@/js/components/Campaign/Audience/LeadsFiltersEditWrapper.vue";

defineProps({
	pack: {
		type: Object,
		required: true,
	}
});
const emit = defineEmits(["close"]);

const closePopup = (updatedPack) => {
	emit("close", updatedPack);
}

</script>

<template>
	<Popup
		class="edit-leads-filters"
		aria-label="Edit Leads Filters (Popup)"
		@close="closePopup"
	>
		<div class="edit-leads-filters__title h6">Edit lead filtering rules</div>
		<LeadsFiltersEditWrapper
			:pack="pack"
			@update:pack="closePopup"
		/>
	</Popup>
</template>

<style lang="sass">
.edit-leads-filters
	&__
		&title
			margin-bottom: 20px
</style>
